import { render } from "./AppTagContainer.vue?vue&type=template&id=0c356fd5&scoped=true&ts=true"
import script from "./AppTagContainer.vue?vue&type=script&lang=ts"
export * from "./AppTagContainer.vue?vue&type=script&lang=ts"

import "./AppTagContainer.vue?vue&type=style&index=0&id=0c356fd5&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c356fd5"]])

export default __exports__